export enum SettingMenuItemType {
  LOG_IN_AND_SECURITY,
  NOTIFICATIONS,
  OTHER,
  MANAGE_SUBSCRIPTIONS,
  BLOCKED_USERS,
}
